<style scoped>
    @import url("../../styles/mv/graficomv.scss");
</style>

<template>
    <div class="box_graficomv">

        <div class="boxTitGraf">
            <span class="titGraf">{{ this.t }}</span>
        </div>

        <div class="semDadosGraf" v-if="!flagApex">
            <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
            <div>AINDA NÃO HÁ DADOS</div>
        </div>

        <apexchart v-if="flagApex" class="ajusteApexGraf" ref="chartA" :series="series" :options="options"></apexchart>

    </div>
</template>

<script>
import axios from 'axios'
export default {

    props:['t','r','payload','name_key'],

    data() {
        return {
            liExib:[], // value
            labelsDatas:[], // date

            flagApex:true,
            series: [
                {
                    name: 'Entrada',
                    type: 'column',
                    //data: [18, 20, 22, 20, 16, 15],
                    data: [0, 0, 0, 2, 0, 4]
                },
                /*{
                    name: 'Saída',
                    type: 'line',
                    data: [0, 0, 0, 0, 0, 0],
                    dashArray: 5  // Define a linha como pontilhada
                }*/
            ],
            options:{
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false  // Desativa o menu (toolbar)
                    },
                    //width: '280px' // Pode ser um valor em pixels (px) ou percentual (%)
                },
                stroke: {
                    width: [0, 4],
                    dashArray: [0, 5]  // Faz a segunda série (linha) ser pontilhada
                },
                labels: ['', '', '', '', '', ''],
                yaxis: { 
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2); // 2 casas decimais
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value.toFixed(2); // Limita a 2 casas decimais
                        }
                    },
                    x: {
                        /*formatter: function (value, { dataPointIndex }) {
                            const labels = this.w.config.labelsDatas || [];
                            return labels[dataPointIndex] || 'Data não disponível';
                        }*/
                        formatter: null // -- adicionado dinamicamente
                    }
                },
            },
        }
    },

    methods:{
        //
        formatTooltipX(value, { dataPointIndex }) {
            return this.labelsDatas[dataPointIndex] || 'Data não disponível';
        }
    },

    created() {
        //
        // this.series[0].data = liFinalIN_apex
        // this.series[1].data = liFinalOut_apex

        //console.log('t: ',this.t)
        
        if (this.r != "") {

            let self = this

            //let params = {'cliente':'cliente2'} // -- teste 04/05/2025
            let params = this.payload // -- props

            const url = self.$store.state.pathAxiosBASE + this.r // -- soma string
            //console.log('url: ',url)

            axios.post(url, params).then(function (res) {

                //console.log(res.data.result)
                //console.log('name_key: ', self.payload.name_key)
                let liRcv = []

                // -- (v1)
                //if (self.r == '/leituraluz') { liRcv = res.data.result['li_luz_on_per_day'] }
                //else if (self.r == '/alvoif') { liRcv = res.data.result['li_if_per_day']}
                //else if (self.r == '/ndiclassic') { liRcv = res.data.result['li_ndi_per_day']}
                //else if (self.r == '/issclassic') { liRcv = res.data.result['li_iss_per_day'] }
                //else { liRcv = res.data.result }
                
                liRcv = res.data.result
                //console.log('liRcv: ', liRcv)
                let c = 0
                //console.log('liRcv[init][data]: ', liRcv[c])
                //console.log('liRcv[init][data]: ', liRcv[c]['data'])
                while (c < liRcv.length) {

                    self.liExib.push(liRcv[c][self.payload.name_key])
                    self.labelsDatas.push(liRcv[c]['date'])
                    
                    c++
                }
                //console.log('liRcv[last][data]: ', liRcv[c-1]['data'])
                
                self.series[0].data = self.liExib // -- apex graph

                self.options.tooltip.x.formatter = self.formatTooltipX.bind(self);
            })
        }

    }
}
</script>